import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 10l4 4m0 -4l-4 4","key":"svg-1"}]]

const IconCircleX = createReactComponent('outline', 'circle-x', 'CircleX', __iconNode);

export default IconCircleX;